import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/keyboard';
import 'swiper/css/autoplay';


document.addEventListener('alpine:init', () => {
    Alpine.data('initStationsSlider', () => ({
        open: false,
        swiper: {},
        init() {
            new Swiper(this.$refs.swiperContainer, {
                modules: [Navigation, Pagination, EffectFade, Autoplay],
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 32,
                autoplay: {
                    delay: 0,
                },
                speed: 10000,
                fadeEffect: {
                    crossFade: true
                },

                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                // And if we need scrollbar
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
            })

            new Swiper(this.$refs.swiperContainerTwo, {
                modules: [Navigation, Pagination, Autoplay],
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 42,
                autoplay: {
                    delay: 0,
                    reverseDirection: true
                },
                speed: 10000,
            })
        }
    }))
})